module.exports = __webpack_public_path__ + "static/media/banner2.179a9eb4.jpg";